import { inject, isDevMode } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { JwtService } from '@app/core/auth';

let isRedirecting = false;
let redirectResetTimer: ReturnType<typeof setTimeout> | null = null;

export const jwtInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const jwtService = inject(JwtService);

  const excludedUrls = ['/auth/login', '/auth/logout', '/auth/refresh'];
  if (excludedUrls.some(url => request.url.includes(url))) {
    return next(request);
  }

  const token = jwtService.getToken();
  if (!token) return next(request);

  const modifiedRequest = request.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  });

  return next(modifiedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        handle401Error(jwtService);
      }
      if (isDevMode()) {
        console.warn(`[JwtInterceptor] HTTP ${error.status} error on ${request.method} request`);
      }
      return throwError(() => error);
    })
  );
};

function handle401Error(jwtService: JwtService): void {
  if (isRedirecting) return;
  isRedirecting = true;

  if (redirectResetTimer !== null) clearTimeout(redirectResetTimer);

  jwtService.removeToken();
  setTimeout(() => {
    jwtService.redirectLoginPage();
    redirectResetTimer = setTimeout(() => {
      isRedirecting = false;
      redirectResetTimer = null;
    }, 2000);
  }, 100);
}
